import { createContext, useEffect, useState } from "react";

export const CoeReportContentContext = createContext();

const initialReportContentState = {
  studentMalpracticeDetails: "",
  toConsiderResultsOfVariousUGandPG:"",
};

export const STUDENT_MALAPRACTICE_DETAILS = "studentMalpracticeDetails";
export const TO_CONSIDER_RESULTS_OF_VARIOUS_UG = "toConsiderResultsOfVariousUGandPG";

export const CoeReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <CoeReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </CoeReportContentContext.Provider>
  );
};
